import React, { Component } from 'react';
import {
    List,
    TextField,
    EmailField,
    NumberField,
    Pagination,
    Datagrid,
    ArrayField,
    SingleFieldList,
    ChipField,
    DateField,
} from 'react-admin';

export class HEXSelectorClientTelemetricsList extends Component {
    render() {
        return (
            <List title="Client Telemetrics" {...this.props} pagination={<Pagination rowsPerPageOptions={[10, 25, 50, 100, 250]} />}>
                <Datagrid>
                <DateField label="Time Stamp" source="timestamp"></DateField>
                <EmailField label="User" source="userEmail"></EmailField>
                <ArrayField source="customCurrencies">
                    <SingleFieldList>
                        <ChipField source="value"></ChipField>
                    </SingleFieldList>
                </ArrayField>
                <NumberField source="quotationCount" label="Quotations in Database"></NumberField>
                <NumberField source="databaseSize" label="User Database Size (KB)"></NumberField>
                <NumberField source="screenResolutionX" label="Screen Width"></NumberField>
                <NumberField source="screenResolutionY" label="Screen Height"></NumberField>
                <NumberField source="logicalCpuCores" label="CPU Cores"></NumberField>
                <NumberField source="totalRam" label="RAM (GB)"></NumberField>
                <TextField source="osFullName" label="OS Name"></TextField>
                <TextField source="osPlatform" label="OS Plateform"></TextField>
                <TextField source="osVersion" label="OS Version"></TextField>
                </Datagrid>
            </List>
        );
    }
}